﻿import { useState, useEffect } from 'react';
import { products } from '../Endpoints'

export const calculateLeastRequiredOrBundledADAvailable = (productAccessDevices, accessDeviceAvailability) => {
  if (!productAccessDevices.some(ad => ad.Required || ad.Bundled)) return
  let requiredOrBundledADs = productAccessDevices.filter(ad => ad.Required || ad.Bundled).map(ad => ad.ProductDetails?.ProductId)
  return Math.min(...accessDeviceAvailability.map(ada => requiredOrBundledADs.length > 0 && requiredOrBundledADs.includes(ada.ProductId) ? +ada.Availability : null).filter(ada => ada !== null))
}

export const useAccessDeviceAvailability = (isAccessDevice, hasAccessDevice, product, bookingFlowContext) => {
  const [accessDevices, setAccessDevices] = useState(null);
  const [pending, setPending] = useState(false);
  const [mandatoryAccessDeviceNotAvailable, setMandatoryAccessDeviceNotAvailable] = useState(false);
  const [mandatoryAccessDeviceAvailability, setMandatoryAccessDeviceAvailability] = useState(null);
  const isReservedProduct = (product.Type === "RESERVED")
  const optional = accessDevices && accessDevices.length && accessDevices.some(device => !device.Required && !device.Bundled);

  useEffect(() => {
    let isSubscribed = true;

    const getAccessDevices = async () => {
      let accessDevicesIds = [];
      if (hasAccessDevice) accessDevicesIds = product.AccessDevices.map(device => { return { ProductId: device.ProductDetails?.ProductId } });
      if (isAccessDevice) accessDevicesIds = [{ ProductId: product.ProductId }];
      const params = {
        accessDevices: accessDevicesIds
      }
      setPending(true);
      if (isSubscribed) {
        if (!hasAccessDevice && !isAccessDevice) {
          //setMandatoryAccessDeviceNotAvailable(true);
          return
        }

        const response = await products.getAccessDeviceAvailability(params);
        if (response.status === 200) {
          if (isAccessDevice) {
            let availability = +response.body?.AccessDevices[0].Availability
            product.Availability = availability
            setMandatoryAccessDeviceAvailability(availability)
            setMandatoryAccessDeviceNotAvailable(availability && availability < 1)
          }
          else {
            let leastRequired = calculateLeastRequiredOrBundledADAvailable(product.AccessDevices, response.body?.AccessDevices)
            product.AccessDevices.forEach((device, n) => {
              product.AccessDevices[n].Availability = +(response.body?.AccessDevices.find(d => d.ProductId === device.ProductDetails?.ProductId)).Availability
            })
            setMandatoryAccessDeviceAvailability(leastRequired)
            setMandatoryAccessDeviceNotAvailable(leastRequired && leastRequired < 1)
          }
          setAccessDevices(hasAccessDevice ? product.AccessDevices : isAccessDevice ? [product] : null)
          setPending(false);
        } else {
          //Set availability to 0 if error
          setMandatoryAccessDeviceAvailability(null)
          setMandatoryAccessDeviceNotAvailable(true);

          //**********
          setAccessDevices(hasAccessDevice ? product.AccessDevices : isAccessDevice ? [product] : null);
          setPending(false);
          console.log("ERROR");
        }
      }
      return
    }
    if (!isReservedProduct && (isAccessDevice || hasAccessDevice)) getAccessDevices();
    return () => isSubscribed = false;
  }, [product])
  return [accessDevices, pending, optional, mandatoryAccessDeviceNotAvailable, mandatoryAccessDeviceAvailability];
}
